<div id="driverWizardContainer">
    <section class="bg-light" id="main">
        <div class="container">
            <router-outlet></router-outlet>
        </div>
    </section>
</div>